import actions from '../actions/projects';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
